// extracted by mini-css-extract-plugin
export default {"wrapper":"list-item-checkbox__wrapper--p5egW"};